// Оплата

import payments from "./payments";
import Analytics from "../marketing/analytics";

class PaymentBlock {
    constructor(button) {
        this.disableClass = "disabled";
        this.button = button;
        this.button.addEventListener("click", (e) => this.createPayment(e));
    }

    createPayment(e) {
        e.preventDefault();
        if (this.isDoubleClick()) {
            return false;
        }
        this.disableButton();
        const amount = this.getPaymentAmount();
        const email = this.button.dataset.email || window.DA.user.username;
        Analytics.reachGoal('PAYMENT_BY_CARD',
            {
                order_price: amount,
                currency: "RUB"
            }
        );
        payments.make(email, amount, { onError: this.enableButton.bind(this) });
    }

    onAmountChange(e) {
        if (!e.target.value) {
            return;
        }
        this.button.dataset.amount = e.target.value;
    }

    getPaymentAmount() {
        return Number.parseInt(this.button.dataset.amount);
    }

    isDoubleClick() {
        return this.button.classList.contains(this.disableClass);
    }

    disableButton() {
        this.button.setAttribute("disabled", "disabled");
        this.button.classList.add(this.disableClass);
    }

    enableButton() {
        this.button.removeAttribute("disabled");
        this.button.classList.remove(this.disableClass);
    }
}

function initPayment() {
    document.querySelectorAll(".js-payment").forEach((el) => new PaymentBlock(el));
}

function initPaymentWithInput(btnClass = ".js-payment-button", inputClass = ".js-payment-amount") {
    const btn = document.querySelector(btnClass);
    const block = new PaymentBlock(btn);
    const input = document.querySelector(inputClass);
    input.addEventListener("change", block.onAmountChange.bind(block));
}

export default {
    init: initPayment,
    initWithInput: initPaymentWithInput,
};
